import { useCache } from '@/hooks/common/useCache'
import { type TokenType } from '@/api/login/types'

const { wsCache, WS_PREFIX } = useCache()

const AccessTokenKey = `${WS_PREFIX}ACCESS_TOKEN`
const RefreshTokenKey = `${WS_PREFIX}REFRESH_TOKEN`

// 获取token
export const getAccessToken = () => {
  // 此处与TokenKey相同，此写法解决初始化时Cookies中不存在TokenKey报错
  const accessToken = wsCache.get(AccessTokenKey)
  return accessToken ? accessToken : wsCache.get(`${WS_PREFIX}ACCESS_TOKEN`)
}

// 刷新token
export const getRefreshToken = () => {
  return wsCache.get(RefreshTokenKey)
}

// 设置token
export const setToken = (token: TokenType) => {
  wsCache.set(RefreshTokenKey, token.refreshToken)
  wsCache.set(AccessTokenKey, token.accessToken)
}

// 删除token
export const removeToken = () => {
  wsCache.delete(AccessTokenKey)
  wsCache.delete(RefreshTokenKey)
}

/** 格式化token（jwt格式） */
export const formatToken = (token: string): string => {
  return 'Bearer ' + token
}
